import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { FormControl } from "react-bootstrap";
import { FieldArray, formValueSelector, reduxForm } from "redux-form";
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { connect, useSelector } from "react-redux";

import Link from "../../Link/Link";
import ManageSubCategoryItem from "../ManageSubCategoryItem/ManageSubCategoryItem";
import Loader from "../../Common/Loader/Loader";

import messages from "../../../locale/messages";
import submit from "./submit"

import noResult from "../../../../public/Icons/noResult.svg"

import BaseFareModal from "../ManageSubCategoryItem/BaseFareModal/BaseFareModal";
import bt from '../../../components/commonStyle.css';
import s from './ManageSubCategoryList.css';

const ManageSubCategoryList = ({
    handleSubmit,
    subCategoryDetails,
    loading,
    intl: { formatMessage },
    submitting,
    initialize,
    profileId,
    userCategoryDetails,
    categoryPricingDetails,
    currency,
    categoryName,
    change
}) => {
    const [searchList, setSearchList] = useState('');
    const subcategory = formValueSelector('ManageSubCategoryForm')
    const categories = useSelector((state) => subcategory(state, 'categories'))

    useEffect(() => {
        initialize({
            categories: [],
            categoryId: subCategoryDetails?.getActiveSubCategory?.results?.[0]?.categoryId,
            profileId: profileId
        });
    }, []);

    useEffect(() => {
        const selectedCategories = [];
        if (userCategoryDetails?.getUserCategory?.length > 0) {
            userCategoryDetails.getUserCategory.forEach((userItems) => {
                const exist = subCategoryDetails?.getActiveSubCategory?.results?.some((item) =>
                    item.id === userItems.subCategoryId && item.categoryId === userItems.mainCategoryId
                );

                if (exist) {
                    if (userItems.currency !== currency) {
                        selectedCategories.push({
                            categoryId: userItems.mainCategoryId,
                            subCategoryId: userItems.subCategoryId,
                            baseFare: userItems.basePrice,
                            currency
                        });
                    }
                    else {
                        selectedCategories.push({
                            categoryId: userItems.mainCategoryId,
                            subCategoryId: userItems.subCategoryId,
                            baseFare: userItems.basePrice,
                            currency: userItems.currency
                        });
                    }

                }
            });
            change("categories", selectedCategories);
            change("categoryId", subCategoryDetails?.getActiveSubCategory?.results?.[0]?.categoryId);
            change("profileId", profileId);
        }
    }, []);

    const handleKeywordSearch = useCallback((searchValue) => {
        setSearchList(searchValue);
        const variables = { searchList: searchValue };
        if (subCategoryDetails?.refetch) {
            subCategoryDetails.refetch(variables);
        }
    }, [subCategoryDetails?.refetch]);

    const renderSubCategories = useCallback(({ fields }) => {
        const handleToggleChange = useCallback((categoryId, subCategoryId, isChecked, baseFare) => {
            const existingIndex = fields.getAll()?.findIndex((item) => item.subCategoryId === subCategoryId);
            if (isChecked) {
                if (existingIndex > -1) {
                    fields.remove(existingIndex);
                    fields.insert(existingIndex, { categoryId, subCategoryId, baseFare, currency });
                } else {
                    fields.push({ categoryId, subCategoryId, baseFare, currency });
                }
            } else {
                if (existingIndex > -1) fields.remove(existingIndex);
            }
        });

        return (
            <>
                <BaseFareModal categories={categories} subCatgeoryChange={change} />
                {subCategoryDetails?.getActiveSubCategory?.results?.length > 0 ? (
                    <div className={s.manageSubCategoryCardContainer}>
                        {subCategoryDetails.getActiveSubCategory.results.map((item) => {
                            const isUserItems = userCategoryDetails?.getUserCategory?.find((userItem) =>
                                userItem.mainCategoryId === item.categoryId && userItem.subCategoryId === item.id
                            );
                            const isToggle = categories ? categories?.some(
                                c => c.subCategoryId === item.id && c.categoryId === item.categoryId
                            ) : userCategoryDetails?.getUserCategory?.find((userItem) =>
                                userItem.mainCategoryId === item.categoryId && userItem.subCategoryId === item.id);

                            const subCategoryPrice = categoryPricingDetails?.getCategoryPricing?.results.find((price) =>
                                price.subCategoryId === item.id
                            );


                            return (
                                <div key={item.id} className={cx(s.manageSubCategoryCard, 'manageSubCategoryCardRtl')}>
                                    <ManageSubCategoryItem
                                        subCategoryId={item.id}
                                        categoryId={item.categoryId}
                                        subCategoryName={item.name}
                                        image={item.image}
                                        onToggle={handleToggleChange}
                                        isDefaultChecked={isToggle}
                                        baseFare={isUserItems?.basePrice ? isUserItems.basePrice : subCategoryPrice?.basePrice}
                                        multiplierValue={subCategoryPrice?.multiplierValue}
                                        pricingType={item.pricingType}
                                        isPriceEditable={subCategoryPrice?.isPriceEditable}
                                        profileId={profileId}
                                        userCurrency={currency}
                                    />
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className={s.manageSubServiceCardNoResultContainer}>
                        <div className={s.manageSubServiceCardNoResultImgBox}>
                            <img src={noResult} alt="SubCategoryNoListImgContainer" className={s.manageSubServiceCardNoResultImg} />
                        </div>
                        <div className={s.manageSubServiceCardNoResultText}><FormattedMessage {...messages.noResult} /></div>
                    </div>
                )}
            </>
        );
    }, [subCategoryDetails?.getActiveSubCategory?.results, userCategoryDetails?.getUserCategory, categoryPricingDetails?.getCategoryPricing?.results, currency, profileId]);

    return (
        <form onSubmit={handleSubmit(submit)}>
            <div className={cx(s.heading, 'textAlignRightRTL')}>
                <div className='addPageHeadingFlexContainer'>
                    <span>{categoryName}</span>
                    <Link to={`/siteadmin/partners/category/${profileId}`} className={cx(bt.btnSecondary, s.displayInlineBlock)}>
                        {formatMessage(messages.goBack)}
                    </Link>
                </div>
            </div>
            <div className={cx(s.searchInput, 'searchInputRTL')}>
                <FormControl
                    type='text'
                    placeholder={formatMessage(messages.searchOnly)}
                    onChange={(e) => handleKeywordSearch(e.target.value)}
                    className={bt.formControlInput}
                    value={searchList}
                />
            </div>
            <FieldArray name="categories" component={renderSubCategories} />
            {subCategoryDetails?.getActiveSubCategory?.results?.length > 0 && (
                <div className={s.manageSubServiceSaveBtnBox}>
                    <Loader
                        type="button"
                        label={formatMessage(messages.saveButton)}
                        show={loading}
                        buttonType="submit"
                        className={cx(s.button, bt.btnPrimary, 'loaderButtonFlex')}
                        disabled={submitting || loading}
                    />
                </div>
            )}
        </form>
    );
};

const mapState = (state) => ({
    loading: state?.loader?.updateUserCategory
});

export default reduxForm({
    form: "ManageSubCategoryForm",
    onSubmit: submit
})(
    injectIntl(
        withStyles(bt, s)(
            connect(mapState)(ManageSubCategoryList)
        )
    )
);